import {
    IMG_FORMAT_JPG,
    IMG_FORMAT_PNG,
    VIDEO_FORMAT_MOV,
    VIDEO_FORMAT_MP4,
    VIDEO_FORMAT_QT,
} from '../marketplace-custom-config';

const typeConfig = {
    [IMG_FORMAT_PNG]: 'image',
    [IMG_FORMAT_JPG]: 'image',
    [VIDEO_FORMAT_MP4]: 'video',
    [VIDEO_FORMAT_MOV]: 'video',
    [VIDEO_FORMAT_QT]: 'video',
    'application/pdf': 'document',
};

/** convert s3 files into sdk format */
export const sdkImagesDto = (
    {
        Key,
        publicPath,
        position,
        description,
        gallerytype,
        fileName,
        originalname,
        mimetype,
        type,
        isdefaultavatar,
    },
    useDecoding = false
) => {
    const getDecodedDesc = desc => {
        try {
            return atob(desc);
        } catch (e) {
            return desc;
        }
    };

    return {
        attributes: {
            variants: {
                'landscape-crop': {
                    height: 267,
                    width: 400,
                    name: 'landscape-crop',
                    url: publicPath,
                },
                'landscape-crop2x': {
                    height: 533,
                    width: 800,
                    name: 'landscape-crop2x',
                    url: publicPath,
                },
            },
        },
        id: {
            uuid: Key,
        },
        type: typeConfig[mimetype],
        mimetype,
        position: Number(position),
        description: useDecoding && description ? getDecodedDesc(description) : description,
        gallerytype,
        fileName: fileName || originalname,
        __type: type,
        isDefaultAvatar: Boolean(isdefaultavatar),
    };
};
